<template>
  <b-card class="border-none">
    <b-input-group class="">
      <b-form-input
        class="border-none shadow-lg"
        type="text"
        min="0.00"
        v-model="search"
        @input="dataload"
        placeholder="Enter Search...."
      ></b-form-input>

      <b-input-group-append>
        <b-button
          variant="white"
          class="flex items-center shadow-lg"
          aria-label="search"
          @click="dataload()"
        >
          <feather-icon
            class="cursor-pointer mr-2"
            icon="SearchIcon"
            svgClasses="w-4 h-4"
          ></feather-icon>
        </b-button>
      </b-input-group-append>
    </b-input-group>
    <el-table
      class="table-responsive table-flush mt-6"
      header-row-class-name="thead-light table-th-color"
      :data="displayedPages"
      border
    >
      <el-table-column
        label="Title"
        min-width="250px"
        prop="title"
        class="ml-12"
        sortable
      >
        <template v-slot="{ row }">
          <p class="font-semibold text-left name mb-0 text-sm">
            {{ row.heading }}
          </p>
        </template>
      </el-table-column>

      <el-table-column label="Edited By" prop="editedby" sortable>
        <template v-slot="{ row }">
          <p
            class="font-semibold text-left name mb-0 text-sm"
            v-if="row.isEdited"
          >
            {{
              row.editedBy.at(-1)._user.firstname +
                " " +
                row.editedBy.at(-1)._user.lastname || " "
            }}
          </p>
        </template>
      </el-table-column>

      <el-table-column
        label="Actions"
        min-width="100px"
        class-name="text-center"
      >
        <template slot-scope="scope">
          <div class="flex justify-center items-center">
            <feather-icon
              icon="EditIcon"
              svgClasses="w-6 text-blue-500 cursor-pointer"
              class="mr-2"
              @click="handleEdit(scope)"
            ></feather-icon>
            <feather-icon
              icon="Trash2Icon"
              svgClasses="w-6 text-red-600 cursor-pointer"
              class="ml-2"
              @click="handleDelete(scope)"
            ></feather-icon>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <b-card-footer class="py-4 d-flex justify-content-end">
      <base-pagination
        v-model="currentPage"
        :per-page="perPage"
        :total="totalPages"
      ></base-pagination>
    </b-card-footer>
  </b-card>
</template>
<script>
import projects from "./projects";
import { mapState } from "vuex";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";
export default {
  name: "light-table",

  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  data() {
    return {
      projects,
      currentPage: 1,
      editModal: false,
      perPage: 8,
      search: "",
    };
  },
  watch: {
    // search: {
    //   handler: _.debounce(async function (val) {
    //     this.getAll();
    //     this.currentPage = 1;
    //   }, 500),
    // },
  },
  methods: {
    async dataload() {
      let payload = {
        search: this.search,
      };
      await this.$store.dispatch("services/getbanner", payload);
    },
    handlePageChange(value) {
      this.currentPage = value;
    },
    async handleEdit(scope) {
      let { row } = scope;
      this.$router.push({ name: "service-edit-banner" });
      await this.$store.commit("services/SELECT_Banner", row);
    },
    async handleDelete(data) {
      const result = await this.deleteAlert();
      if (result.isConfirmed) {
        this.deleteData(data);
      }
    },
    deleteAlert() {
      return this.$swal({
        title: "Are you sure?",
        html: `<p class="text-center">You won't be able to revert this!</p>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#830c81",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });
    },
    async deleteData({ row }) {
      const payload = { _id: row._id };
      let loader = this.$loading();
      try {
        await this.$store.dispatch("services/deletebanner", payload);
        loader.close();
      } catch (error) {
        loader.close();
      }
    },
  },
  computed: {
    ...mapState("services", { get_AllBanner: "get_AllBanner" }),

    displayedPages() {
      return this.get_AllBanner.slice(
        (this.currentPage - 1) * this.perPage,
        this.currentPage * this.perPage
      );
    },
    totalPages() {
      return this.get_AllBanner.length;
    },
  },
  mounted() {
    this.dataload();
  },
};
</script>
